import { ApiError } from 'services/api';

export function isForceLogout({ code }: ApiError) {
  return code === 'FORCE_LOGOUT';
}
